import styled from "styled-components";
import { Flex } from "../../../components/box";

export const Styles = styled.div`
  width: 100%;
  padding: 30px 30px 0;
  // background-color: #f3f6fb;
  @media (max-width: 700px) {
    padding: 20px 4%;
  }
  h1 {
    color: #1a1f36;
    font-size: 18px;
  }
`;

export const StylesFundAccount = styled(Flex)`
  h3 {
    font-weight: 700;
    font-size: 16px;
    line-height: 21px;
    color: #000000;
    padding-bottom: 8px;
  }
  p,
  .text p {
    font-weight: 400;
    font-size: 12px;
    line-height: 16px;
    color: #686868;
  }

  .main-box {
    background: #f3f6fb;
    border-radius: 4px;
    padding: 15px;
    cursor: pointer;
  }
  .text {
    h4 {
      font-weight: 500;
      font-size: 14px;
      line-height: 18px;

      color: #131313;
      padding-bottom: 0px;
    }
  }
`;

export const StylesCreateNew = styled.div`
  background: #f3f6fb;
  border-radius: 4px;
  padding: 30px 35px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  div {
    margin-bottom: 40px;
    width: 50%;
    justify-content: space-between;

    &:last-child {
      margin-bottom: 0;
      width: 100%;
    }
  }
  h5 {
    font-weight: 500;
    font-size: 14px;
    line-height: 18px;

    color: #000000;
    text-align: left;
    padding-bottom: 16px;
  }
  h4 {
    font-weight: 700;
    font-size: 14px;
    line-height: 18px;
  }
  h6 {
    font-weight: 400;
    font-size: 14px;
    line-height: 21px;
  }
  .bank-wire {
    margin-bottom: 20px;
  }

  p {
    margin: 0;
    text-align: left;
    font-weight: 400;
    font-size: 14px;
    line-height: 18px;

    color: #000000;
    align-items: center;
    svg {
      margin-right: 10px;
    }
    span {
      background: #3ab75d;

      border: 1px solid #3ab75d;
      border-radius: 15px;
      font-weight: 400;
      font-size: 12px;
      line-height: 14px;

      color: #ffffff;
      padding: 5px 8px;
      margin-left: 8px;
    }
  }

  .crypto {
    margin-bottom: 0;
    div:nth-of-type(1),
    div:nth-of-type(2) {
      margin-bottom: 0;
    }
    h3 {
      padding-bottom: 12px;
    }
  }
`;
